import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface IBreadcrumbExtraItem {
  label: string;
  /** Si se define, el ítem es clickeable y ejecuta esta acción (ej. volver
   * a la vista anterior dentro del mismo componente). Si es null, el ítem
   * se muestra como el nivel actual (no clickeable). */
  action?: (() => void) | null;
}

/**
 * Servicio para extender el breadcrumb global (common-layout.component)
 * con niveles adicionales que NO corresponden a una ruta de Angular real
 * — como "Ver Detalle" dentro de Balance / Estado Resultado, que solo
 * cambia una variable interna (isVisible/tableType) sin navegar.
 *
 * A pedido de Mauro (2026-08-25): en vez de crear un breadcrumb propio y
 * estático debajo del botón "Volver" en cada pantalla de detalle, se
 * reutiliza el breadcrumb global ya existente (con ícono de casa, arriba
 * del contenido) — ahorra espacio y aprovecha que ya es clickeable.
 */
@Injectable({ providedIn: 'root' })
export class BreadcrumbExtraService {
  private itemsSubject = new BehaviorSubject<IBreadcrumbExtraItem[]>([]);
  items$ = this.itemsSubject.asObservable();

  set(items: IBreadcrumbExtraItem[]) {
    this.itemsSubject.next(items);
  }

  clear() {
    this.itemsSubject.next([]);
  }
}
